<template>
    <v-dialog
        v-model="$store.state.newTransact.transacting"
        fullscreen 
        persistent
        transition="dialog-transition"
    >
        <v-container fluid>
            <v-toolbar dense dark color="secondary" class="white--text">
               
                <v-spacer></v-spacer>
                <v-toolbar-title>
                    Transacting
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon 
                @click="$store.state.newTransact.transacting = false;"
                ><v-icon 
                >mdi-close</v-icon></v-btn
            >
            </v-toolbar>
            <v-card class="pb-2">
                <v-container grid-list-xs fluid>
                
                    <div class="text-center" v-if="loadProgress">
                        <v-progress-linear
                            :size="50"
                            color="primary"
                            indeterminate
                        ></v-progress-linear>
                    </div>
                    <v-container
                        grid-list-xs
                        fluid
                        v-if="loadData"
                        style="margin-top:0px;padding-top:0px;"
                    >
                        <v-row class="margin-top:0px;padding-top:0px;">
                            <v-col
                                cols="7"
                                class="margin-top:0px;padding-top:0px;"
                                ><v-bottom-navigation
                                    :value="value"
                                    color="elevation-3"
                                    dark
                                    background-color="primary"
                                    horizontal
                                    height="25px"
                                    class="margin-top:0px;padding-top:0px;"
                                >
                                    <template v-for="(item, i) in items">
                                        <v-btn
                                            dense
                                            v-bind:key="i"
                                            @click="subMenu = item.action"
                                        >
                                            {{ item.text }}
                                            <v-icon>{{ item.icon }}</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-btn
                                        dense
                                        @click="
                                            $store.state.posting.rdDialogTracking = true
                                        "
                                    >
                                        GPS Tracking
                                        <v-icon>mdi-logout-variant</v-icon>
                                    </v-btn>
                                    <v-btn dense @click="openEditAssig">
                                        Sft. Assignments
                                        <v-icon>mdi-logout-variant</v-icon>
                                    </v-btn>
                                    <v-btn dense @click="openCommentMargin"
                                    class="ml-5"
                                        >
                                        Margin Comment </v-btn
                                    >
                                </v-bottom-navigation>
                                <v-simple-table dense class="tableTrasac">
                                    <tbody>
                                        <tr v-if="subMenu == 1">
                                            <th>ShiftDetail</th>
                                            <th>ShiftDate</th>
                                            <th>Shift</th>
                                            <th>Truck</th>
                                            <th>Trailer</th>
                                            <th>ReplacementUnit</th>
                                            <th colspan="2">Yard</th>
                                        </tr>
                                        <tr v-if="subMenu == 1">
                                            <td>
                                                {{
                                                    ShiftDetail[0][
                                                        'ShiftDetail'
                                                    ]
                                                }}
                                            </td>
                                            <td>
                                                {{ ShiftDetail[0].ShiftDate }}
                                            </td>
                                            <td>
                                                {{ ShiftDetail[0].Shift }}
                                            </td>
                                            <td>
                                                {{ ShiftDetail[0].Truck }}
                                            </td>
                                            <td>
                                                {{ ShiftDetail[0].Trailer }}
                                            </td>
                                            <td>
                                                {{
                                                    ShiftDetail[0]
                                                        .ReplacementUnit
                                                }}
                                            </td>
                                            <td colspan="2">
                                                {{ ShiftDetail[0].Yard }}
                                            </td>
                                        </tr>
                                        <tr v-if="subMenu == 1">
                                            <th colspan="3">Driver</th>
                                            <th colspan="2">
                                                ShiftStartTime
                                            </th>
                                            <th colspan="2">
                                                ShiftEndTime
                                            </th>
                                            <th>
                                                ReadyToTransact
                                            </th>
                                        </tr>
                                        <tr v-if="subMenu == 1">
                                            <td colspan="2">
                                                {{ ShiftDetail[0].Driver }}
                                            </td>
                                            <td colspan="2" class="text-center">
                                                {{
                                                    ShiftDetail[0]
                                                        .ShiftStartTime
                                                }}
                                            </td>
                                            <td colspan="3" class="text-center">
                                                {{
                                                    ShiftDetail[0].ShiftEndTime
                                                }}
                                            </td>
                                            <td>
                                                <v-checkbox v-model="ShiftDetail[0].ReadyToTransact" 
                                                :disabled="disabled"
                                                @change="ReadyToTransact(ShiftDetail[0].ReadyToTransact, ShiftDetail[0].ShiftDetail)"
                                                dense
                                                hide-details 
                                                 ></v-checkbox>
                                            </td>
                                        </tr>

                                        <tr v-if="subMenu == 2">
                                            <th>Total Revenue</th>
                                            <th>Total Payroll</th>
                                            <th>Total Extra Revenue</th>
                                        </tr>
                                        <tr v-if="subMenu == 2">
                                            <td>{{ totalRev }}</td>
                                            <td>{{ totalPay }}</td>
                                            <td>{{ totalExtraRev }}</td>
                                        </tr>
                                        <tr v-if="subMenu == 2">
                                            <th>Total Extra Payroll</th>
                                            <th>Net</th>
                                            <th>Margin</th>
                                        </tr>
                                        <tr v-if="subMenu == 2">
                                            <td>{{ totalExtraPay }}</td>
                                            <td>{{ net }}</td>
                                            <td>
                                                {{
                                                    Number(
                                                        margin * 100
                                                    ).toFixed(2)
                                                }} %
                                            </td>
                                        </tr>
                                        <tr v-if="subMenu == 3">
                                            <td width="80%">
                                                <v-textarea
                                                    class="tdTransc mt-2"
                                                    label="Comments"
                                                    rows="3"
                                                    outlined
                                                    hide-details
                                                    dense
                                                    v-model="
                                                        ShiftDetail[0]
                                                            .AdmComments
                                                    "
                                                    append-icon="mdi-content-save"
                                                    @click:append="
                                                        saveMore(ShiftDetail[0])
                                                    "
                                                ></v-textarea>
                                            </td>
                                            <td>
                                                <v-btn
                                                    color="primary"
                                                    small
                                                    class="my-1"
                                                    tile
                                                    style="margin: 0px;"
                                                    @click="
                                                        $store.state.posting.rdDialogTracking = true
                                                    "
                                                    ><v-icon x-small
                                                        >mdi-logout-variant</v-icon
                                                    >
                                                    GPS Tracking</v-btn
                                                >
                                                <br />
                                                <v-btn
                                                    color="primary"
                                                    class="my-1"
                                                    small
                                                    tile
                                                    style="margin: 0px;"
                                                    @click="
                                                        $store.state.posting.rdDialogTracking = true
                                                    "
                                                    ><v-icon x-small
                                                        >mdi-logout-variant</v-icon
                                                    >
                                                    Sft. Assignments</v-btn
                                                >
                                            </td>
                                        </tr>
                                        <tr v-if="subMenu == 4">
                                            <th width="20%">
                                                OutofProvOdo Start
                                            </th>
                                            <th width="20%">Repl Odo Start</th>
                                            <th width="20%">Odo Start</th>
                                            <th width="20%" colspan="1">
                                                Paperwork Origin
                                            </th>
                                            <th colspan="2">
                                                Dly Summary
                                            </th>
                                        </tr>
                                        <tr v-if="subMenu == 4">
                                            <td>
                                                <v-text-field
                                                    v-model="
                                                        ShiftDetail[0]
                                                            .OutofProvOdoStart
                                                    "
                                                    :disabled="disabled"
                                                    style="width:100px;margin: 0px;padding: 0px;"
                                                    dense
                                                    hide-details
                                                ></v-text-field>
                                            </td>
                                            <td>
                                                <v-text-field
                                                    v-model="
                                                        ShiftDetail[0]
                                                            .ReplUnitOdoStart
                                                    "
                                                    :disabled="disabled"
                                                    style="width:100px;margin: 0px;padding: 0px;"
                                                    dense
                                                    hide-details
                                                ></v-text-field>
                                            </td>
                                            <td>
                                                <v-text-field
                                                    v-model="
                                                        ShiftDetail[0].OdoStart
                                                    "
                                                    :disabled="disabled"
                                                    style="width:100px;margin: 0px;padding: 0px;"
                                                    dense
                                                    hide-details
                                                ></v-text-field>
                                            </td>
                                            <td>
                                                <v-combobox
                                                    v-model="
                                                        ShiftDetail[0][
                                                            'PaperworkOrigin'
                                                        ]
                                                    "
                                                    hide-details
                                                    dense
                                                    :disabled="disabled"
                                                    :items="PaperworkOrigin"
                                                    :item-text="'Origin'"
                                                    :item-value="'ID'"
                                                    style="font-size: 13px; margin: 0px;padding: 0px;"
                                                    auto-select-first
                                                ></v-combobox>
                                            </td>
                                            <td>
                                                <v-checkbox
                                                    style="margin-top: 0px;font-size: 10px; margin: 0px;padding: 0px; "
                                                    class="summary-color"
                                                    v-model="
                                                        ShiftDetail[0][
                                                            'DailySummaryCheck'
                                                        ]
                                                    "
                                                    :disabled="disabled"
                                                    hide-details
                                                ></v-checkbox>
                                            </td>
                                        </tr>
                                        <tr v-if="subMenu == 4">
                                            <th>OutofProvOdo End</th>
                                            <th>Repl Odo End</th>
                                            <th>Odo End</th>
                                            <th colspan="3">Odo Total</th>
                                        </tr>
                                        <tr v-if="subMenu == 4">
                                            <td>
                                                <v-text-field
                                                    v-model="
                                                        ShiftDetail[0]
                                                            .OutofProvOdoEnd
                                                    "
                                                    :disabled="disabled"
                                                    style="width:100px;margin: 0px;padding: 0px;"
                                                    dense
                                                    hide-details
                                                ></v-text-field>
                                            </td>
                                            <td>
                                                <v-text-field
                                                    v-model="
                                                        ShiftDetail[0]
                                                            .ReplUnitOdoEnd
                                                    "
                                                    :disabled="disabled"
                                                    style="width:100px;margin: 0px;padding: 0px;"
                                                    dense
                                                    hide-details
                                                ></v-text-field>
                                            </td>
                                            <td>
                                                <v-text-field
                                                    v-model="
                                                        ShiftDetail[0].OdoEnd
                                                    "
                                                    :disabled="disabled"
                                                    style="width:100px;margin: 0px;padding: 0px;"
                                                    dense
                                                    hide-details
                                                ></v-text-field>
                                            </td>
                                            <td>
                                                <v-text-field
                                                    v-model="
                                                        ShiftDetail[0].OdoTotal
                                                    "
                                                    disabled
                                                    style="width:100px;margin: 0px;padding: 0px;"
                                                    dense
                                                    hide-details
                                                ></v-text-field>
                                            </td>
                                            <td>
                                                <v-btn
                                                    color="success"
                                                    small
                                                    @click="saveShift"
                                                    :disabled="disabled"
                                                    >Save</v-btn
                                                >
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-col>
                            <v-col cols="3">
                                <v-toolbar
                                    height="30"
                                    color="primary"
                                    dense
                                    style="color: #fff;"
                                >
                                    Products
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                                <v-progress-linear
                                    size="large"
                                    indeterminate
                                    color="primary"
                                    v-if="progress"
                                ></v-progress-linear>
                                <table class="tbl-trs">
                                    <thead>
                                        <tr>
                                            <th>Order #</th>
                                            <th>Product</th>
                                            <th>REQ Qty</th>
                                            <th>GRS Qty</th>
                                            <th>NET Qty</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="(prd, i) in products">
                                            <tr
                                                :key="i"
                                                style="text-align: center;"
                                            >
                                                <td>{{ prd.OrderID }}</td>
                                                <td>{{ prd.Product }}</td>
                                                <td>
                                                    {{ prd.Quantity }}
                                                </td>
                                                <td>
                                                    {{ prd.DeliveredQuantity }}
                                                </td>
                                                <td>
                                                    {{ prd.TempAdjQuantity }}
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </v-col>

                            <v-col
                                cols="2"
                                class="margin-top:0px;padding-top:0px;"
                            >
                                <v-btn
                                    color="primary"
                                    class="mb-1"
                                    :disabled="disabled"
                                    block
                                    @click="onFinalizeShift(1)"
                                    small
                                    >Finalize</v-btn
                                >

                                <v-btn
                                    color="primary"
                                    class="mb-1"
                                    :disabled="!disabled"
                                    block
                                    small
                                    @click="onUnFinalizeShift(0)"
                                    >UnFinalize</v-btn
                                >
                                <br />
                                <v-row v-if="ShiftDetail[0].Finalize">
                                    <v-col style="background-color:#00C853;">
                                        <v-checkbox
                                            v-model="ShiftDetail[0].Finalize"
                                            disabled
                                            class="my-auto"
                                            hide-details
                                            style="float: left; color:#fff;font-size: 10px;"
                                        ></v-checkbox>
                                        <h3 style="float: left;color:#fff;">
                                            FINALIZED
                                        </h3>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <!--Table Transact By Shift  327221-->
                        <v-row>
                            <v-col
                                cols="12"
                                style="padding-top: 0px; margin: 0px"
                            >
                                <v-toolbar
                                    color="primary"
                                    height="30"
                                    dense
                                    dark
                                    >Transact By Shift</v-toolbar
                                >
                                <div class="tbl">
                                    <table class="tbl-trs">
                                        <thead>
                                            <tr>
                                                <template
                                                    v-for="(titles,
                                                    i) in orderHeaders"
                                                >
                                                    <th
                                                        :key="i"
                                                        :width="titles.width"
                                                    >
                                                        {{ titles.text }}
                                                    </th>
                                                </template>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template
                                                v-for="(ord, i) in orders"
                                            >
                                                <tr
                                                    :key="i"
                                                    @click="
                                                        loadOrderDetails(
                                                            ord.OrderID
                                                        )
                                                    "
                                                >
                                                    <td>
                                                        <v-icon
                                                            persistent
                                                            class="mx-3"
                                                            color="primary"
                                                            dark
                                                            @click="
                                                                openModalOrder(
                                                                    ord
                                                                )
                                                            "
                                                            >mdi-open-in-new</v-icon
                                                        >
                                                    </td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        {{ ord.LoadNum }}
                                                    </td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        {{ ord.LoadNumOrd }}
                                                    </td>

                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        {{ ord.OrderID }}
                                                    </td>
                                                    <td
                                                        style="text-align:center;background-color:#edd480;"
                                                        v-if="
                                                            ord.OrderStatus ==
                                                                'PRELOAD'
                                                        "
                                                    >
                                                        {{ ord.OrderStatus }}
                                                    </td>
                                                    <td
                                                        style="text-align:center;background-color:#cef5a9;"
                                                        v-else-if="
                                                            ord.OrderStatus ==
                                                                'PRLDISPAT'
                                                        "
                                                    >
                                                        {{ ord.OrderStatus }}
                                                    </td>
                                                    <td
                                                        style="text-align:center;"
                                                        v-else
                                                    >
                                                        {{ ord.OrderStatus }}
                                                    </td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        {{ ord.BOL }}
                                                    </td>
                                                    <td>{{ ord.Customer }}</td>
                                                    <td>{{ ord.Terminal }}</td>
                                                    <td>{{ ord.Station }}</td>
                                                    <td>
                                                        {{ ord.StationCity }}
                                                    </td>
                                                    <td>
                                                        {{ ord.PreloadOrderID }}
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </v-col>
                        </v-row>
                        <!--Table Revenue and PayRoll-->
                        <v-row>
                            <v-col
                                cols="6"
                                style="padding-top: 0px; margin: 0px;"
                            >
                                <v-toolbar
                                    height="30"
                                    color="primary"
                                    dense
                                    style="color: #fff;"
                                >
                                    Revenue
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        class="mb-1 mr-2"
                                        x-small
                                        :disabled="disabled"
                                        @click="newTransactRev()"
                                        >New Transact Revenue</v-btn
                                    >
                                    <v-btn
                                        class="mb-1"
                                        x-small
                                        :disabled="disabled"
                                        @click="transactRev()"
                                        >Transact Revenue</v-btn
                                    >
                                </v-toolbar>
                                <div class="tbl">
                                    <table class="tbl-trs">
                                        <thead>
                                            <tr>
                                                <template
                                                    v-for="(titles,
                                                    i) in transHeaders"
                                                >
                                                    <th
                                                        :key="i"
                                                        :width="titles.width"
                                                    >
                                                        {{ titles.text }}
                                                    </th>
                                                </template>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template
                                                v-for="(itm, i) in revTrans"
                                            >
                                                <tr :key="i">
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        {{ itm.OrderNumber }}
                                                    </td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        {{
                                                            itm.TransactionName
                                                        }}
                                                    </td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        <input
                                                            :disabled="disabled"
                                                            width="10%"
                                                            type="text"
                                                            v-model="
                                                                itm.Quantity
                                                            "
                                                            @blur="
                                                                calculateAmountRevenue(
                                                                    itm
                                                                )
                                                            "
                                                        />
                                                    </td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        <input
                                                            :disabled="disabled"
                                                            width="10%"
                                                            type="text"
                                                            v-model="itm.Rate"
                                                            @blur="
                                                                calculateAmountRevenue(
                                                                    itm
                                                                )
                                                            "
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            :disabled="disabled"
                                                            width="10%"
                                                            type="text"
                                                            v-model="itm.Amount"
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            :disabled="disabled"
                                                            width="10%"
                                                            type="text"
                                                            v-model="itm.InvId"
                                                        />
                                                    </td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        <v-icon
                                                            x-small
                                                            class="mx-3"
                                                            color="success"
                                                            dark
                                                            :disabled="disabled"
                                                            @click="
                                                                saveRevenue(itm)
                                                            "
                                                            >mdi-content-save</v-icon
                                                        >
                                                        <v-icon
                                                            x-small
                                                            class="mx-3"
                                                            color="primary"
                                                            dark
                                                            :disabled="disabled"
                                                            @click="
                                                                openRates(itm)
                                                            "
                                                            >mdi-book-open</v-icon
                                                        >
                                                        <v-icon
                                                            x-small
                                                            class="mx-3"
                                                            color="red"
                                                            dark
                                                            :disabled="disabled"
                                                            @click="
                                                                dltTrnsConfirm(
                                                                    itm
                                                                )
                                                            "
                                                            >mdi-delete-forever-outline</v-icon
                                                        >
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                                <v-row justify="end">
                                    <v-col cols="12">
                                        Total Rev *
                                        <v-chip class="divs" label value>
                                            {{ totalRev }}
                                        </v-chip>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col
                                cols="6"
                                style="padding-top: 0px; margin: 0px"
                            >
                                <v-toolbar
                                    color="primary"
                                    dense
                                    height="30"
                                    style="color: #fff;"
                                    >PayRoll
                                    <v-spacer></v-spacer>
                                    
                                    <v-btn
                                        :disabled="disabled"
                                        depressed
                                        x-small
                                        class="mb-1 mr-2"
                                        @click="newTransactPay()"
                                        >New Transact Payroll</v-btn
                                    >
                                    <v-btn
                                        :disabled="disabled"
                                        depressed
                                        x-small
                                        class="mb-1 "
                                        @click="transactPay()"
                                        >Transact Payroll</v-btn
                                    >
                                </v-toolbar>
                                <div class="tbl">
                                    <table class="tbl-trs">
                                        <thead>
                                            <tr>
                                                <template
                                                    v-for="(titles,
                                                    i) in transPayHeaders"
                                                >
                                                    <th
                                                        :key="i"
                                                        :width="titles.width"
                                                    >
                                                        {{ titles.text }}
                                                    </th>
                                                </template>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template
                                                v-for="(itm, i) in payTrans"
                                            >
                                                <tr :key="i">
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        {{ itm.OrderNumber }}
                                                    </td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        {{
                                                            itm.TransactionName
                                                        }}
                                                    </td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        <input
                                                            :disabled="disabled"
                                                            width="10%"
                                                            type="text"
                                                            v-model="
                                                                itm.Quantity
                                                            "
                                                            @blur="
                                                                calculateAmountPayroll(
                                                                    itm
                                                                )
                                                            "
                                                        />
                                                    </td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        <input
                                                            :disabled="disabled"
                                                            width="10%"
                                                            type="text"
                                                            v-model="itm.Rate"
                                                            @blur="
                                                                calculateAmountPayroll(
                                                                    itm
                                                                )
                                                            "
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            :disabled="disabled"
                                                            width="10%"
                                                            type="text"
                                                            v-model="itm.Amount"
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            :disabled="disabled"
                                                            width="10%"
                                                            type="text"
                                                            v-model="itm.PayId"
                                                        />
                                                    </td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        <v-icon
                                                            x-small
                                                            class="mx-3"
                                                            color="success"
                                                            dark
                                                            @click="
                                                                savePayroll(itm)
                                                            "
                                                            :disabled="disabled"
                                                            >mdi-content-save</v-icon
                                                        >
                                                        <v-icon
                                                            :disabled="disabled"
                                                            x-small
                                                            class="mx-3"
                                                            color="primary"
                                                            dark
                                                            @click="
                                                                openRates(itm)
                                                            "
                                                            >mdi-book-open</v-icon
                                                        >
                                                        <v-icon
                                                            x-small
                                                            class="mx-3"
                                                            color="red"
                                                            dark
                                                            :disabled="disabled"
                                                            @click="
                                                                dltTrnsConfirm(
                                                                    itm
                                                                )
                                                            "
                                                            >mdi-delete-forever-outline</v-icon
                                                        >
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                                <v-row justify="end">
                                    <v-col cols="12">
                                        <v-btn
                                            class="mr-3"
                                            x-small
                                            color="primary"
                                            @click="
                                                $store.state.posting.mod = true
                                            "
                                            >Calculate MOQ</v-btn
                                        >
                                        Total Payroll *
                                        <v-chip class="divs" label value>
                                            {{ totalPay }}
                                        </v-chip>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>

                        <!--Table Extra Revenue and  Extra PayRoll-->
                        <v-row>
                            <v-col
                                cols="6"
                                style="padding-top: 0px; margin: 0px"
                            >
                                <v-toolbar
                                    color="primary"
                                    dense
                                    dark
                                    height="30"
                                    >Extra Revenue
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        dark
                                        icon
                                        left
                                        :disabled="disabled"
                                        @click="openModalNewExt(1, 'Revenue')"
                                        ><v-icon
                                            >mdi-sticker-plus-outline</v-icon
                                        ></v-btn
                                    >
                                </v-toolbar>
                                <div class="tbl">
                                    <table class="tbl-trs">
                                        <thead>
                                            <tr>
                                                <template
                                                    v-for="(titles,
                                                    i) in transHeaders"
                                                >
                                                    <th
                                                        :key="i"
                                                        :width="titles.width"
                                                    >
                                                        {{ titles.text }}
                                                    </th>
                                                </template>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template
                                                v-for="(itm,
                                                i) in extraRevTrans"
                                            >
                                                <tr :key="i">
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        {{ itm.OrderNumber }}
                                                    </td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        {{
                                                            itm.TransactionName
                                                        }}
                                                    </td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        <input
                                                            :disabled="disabled"
                                                            width="10%"
                                                            type="text"
                                                            v-model="
                                                                itm.Quantity
                                                            "
                                                            @blur="
                                                                calculateAmountExtRevenue(
                                                                    itm
                                                                )
                                                            "
                                                        />
                                                    </td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        <input
                                                            :disabled="disabled"
                                                            width="10%"
                                                            type="text"
                                                            v-model="itm.Rate"
                                                            @blur="
                                                                calculateAmountExtRevenue(
                                                                    itm
                                                                )
                                                            "
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            :disabled="disabled"
                                                            width="10%"
                                                            type="text"
                                                            v-model="itm.Amount"
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            :disabled="disabled"
                                                            width="10%"
                                                            type="text"
                                                            v-model="itm.InvId"
                                                        />
                                                    </td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        <v-icon
                                                            :disabled="disabled"
                                                            x-small
                                                            class="mx-3"
                                                            color="success"
                                                            dark
                                                            @click="
                                                                saveRevenue(itm)
                                                            "
                                                            >mdi-content-save</v-icon
                                                        >
                                                        <v-icon
                                                            x-small
                                                            :disabled="disabled"
                                                            class="mx-3"
                                                            color="red"
                                                            dark
                                                            @click="
                                                                dltTrnsConfirm(
                                                                    itm
                                                                )
                                                            "
                                                            >mdi-delete-forever-outline</v-icon
                                                        >
                                                    </td>
                                                </tr>
                                                <tr :key="i">
                                                    <th>Description</th>
                                                    <td colspan="6">
                                                        <input
                                                            :disabled="disabled"
                                                            style="width: 100%;"
                                                            type="text"
                                                            v-model="
                                                                itm.Description
                                                            "
                                                        />
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                                <v-row justify="end">
                                    <v-col cols="12">
                                        Total Extra Revenue *
                                        <v-chip class="divs" label value>
                                            {{ totalExtraRev }}
                                        </v-chip>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col
                                cols="6"
                                style="padding-top: 0px; margin: 0px"
                            >
                                <v-toolbar
                                    color="primary"
                                    dense
                                    height="30"
                                    text-center
                                    dark
                                    >Extra Payroll
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        dark
                                        icon
                                        :disabled="disabled"
                                        left
                                        @click="openModalNewExt(2, 'Payroll')"
                                        ><v-icon
                                            >mdi-sticker-plus-outline</v-icon
                                        ></v-btn
                                    >
                                </v-toolbar>

                                <div class="tbl">
                                    <table class="tbl-trs">
                                        <thead>
                                            <tr>
                                                <template
                                                    v-for="(titles,
                                                    i) in transPayHeaders"
                                                >
                                                    <th
                                                        :key="i"
                                                        :width="titles.width"
                                                    >
                                                        {{ titles.text }}
                                                    </th>
                                                </template>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template
                                                v-for="(itm,
                                                i) in extraPayTrans"
                                            >
                                                <tr :key="i">
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        {{ itm.OrderNumber }}
                                                    </td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        {{
                                                            itm.TransactionName
                                                        }}
                                                    </td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        <input
                                                            :disabled="disabled"
                                                            width="10%"
                                                            type="text"
                                                            v-model="
                                                                itm.Quantity
                                                            "
                                                            @blur="
                                                                calculateAmountExtPayrol(
                                                                    itm
                                                                )
                                                            "
                                                        />
                                                    </td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        <input
                                                            :disabled="disabled"
                                                            width="10%"
                                                            type="text"
                                                            v-model="itm.Rate"
                                                            @blur="
                                                                calculateAmountExtPayrol(
                                                                    itm
                                                                )
                                                            "
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            :disabled="disabled"
                                                            width="10%"
                                                            type="text"
                                                            v-model="itm.Amount"
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            :disabled="disabled"
                                                            width="10%"
                                                            type="text"
                                                            v-model="itm.PayId"
                                                        />
                                                    </td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        <v-icon
                                                            :disabled="disabled"
                                                            x-small
                                                            class="mx-3"
                                                            color="success"
                                                            dark
                                                            @click="
                                                                savePayroll(itm)
                                                            "
                                                            >mdi-content-save</v-icon
                                                        >
                                                        <v-icon
                                                            x-small
                                                            :disabled="disabled"
                                                            class="mx-3"
                                                            color="red"
                                                            dark
                                                            @click="
                                                                dltTrnsConfirm(
                                                                    itm
                                                                )
                                                            "
                                                            >mdi-delete-forever-outline</v-icon
                                                        >
                                                    </td>
                                                </tr>
                                                <tr :key="i">
                                                    <th>Description</th>
                                                    <td colspan="6">
                                                        <input
                                                            :disabled="disabled"
                                                            style="width: 100%;"
                                                            type="text"
                                                            v-model="
                                                                itm.Description
                                                            "
                                                        />
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                                <v-row justify="end">
                                    <v-col cols="12">
                                        Total Extra Payroll *
                                        <v-chip class="divs" label value>
                                            {{ totalExtraPay }}
                                        </v-chip>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-container>
            </v-card>
            <v-dialog
                v-model="$store.state.transacting.dialogAddExt"
                width="600"
            >
                <v-card>
                    <v-toolbar color="secondary" dense>
                        <v-spacer></v-spacer>
                        <v-card-title primary-title style="color:#fff;">
                            Add Extra {{ title }}
                        </v-card-title>
                        <v-spacer></v-spacer>
                        <v-btn
                            dark
                            icon
                            left
                            @click="
                                $store.state.transacting.dialogAddExt = false
                            "
                            ><v-icon>mdi-close</v-icon></v-btn
                        >
                    </v-toolbar>
                    <AddExtraRevenue
                        :Add="params"
                        v-if="$store.state.transacting.dialogAddExt"
                    ></AddExtraRevenue>
                </v-card>
            </v-dialog>

            <CalculateMoq
                :Add="searchShift"
                :dis="disabled"
                v-if="$store.state.posting.mod"
            />

            <v-dialog
                v-model="$store.state.posting.dialog"
                transition="dialog-bottom-transition"
                overlay-color="accent"
                width="1500"
            >
                <OrderData
                    v-if="$store.state.posting.dialog"
                    :isModal="disabled"
                />
            </v-dialog>
        </v-container>
        <v-dialog
            v-model="$store.state.transacting.dialogRate"
            persistent
            :overlay="false"
            width="1300px"
            transition="dialog-transition"
        >
            <ratesModal
                :dataInfo="rateInfo"
                v-if="$store.state.transacting.dialogRate"
            ></ratesModal>
        </v-dialog>
        <UnfinalizeCause
            v-if="$store.state.transacting.unfinalizedCause"
            :ShiftDetail="searchShift"
        ></UnfinalizeCause>
        <edtAssignment
            v-if="$store.state.assignment.dialog"
            :data="ShiftDetail"
        ></edtAssignment>
        <rdTracking
            v-if="$store.state.posting.rdDialogTracking"
            :params="ShiftDetail"
        ></rdTracking>
        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
        <marginComment v-if="$store.state.transacting.marginComment" :ShiftDetail="ShiftDetail"></marginComment>
    </v-dialog>
</template>
<script>
import { mask } from 'vue-the-mask';
import axios from 'axios';
import OrderData from './../OrderEdit.vue';
import AddExtraRevenue from './AddExtra.vue';
import CalculateMoq from './CalculateMoq.vue';
import ratesModal from './RatesModal.vue';

import edtAssignment from './../../Dispatch/Shift Assignments/EditAssignmentsPosting.vue';
import rdTracking from './../../Dispatch/Tracking/ReadGPSTracking.vue';
import ConfirmDialogue from './../../ConfirmDialogue.vue';
import UnfinalizeCause from './UnfinalizedCause.vue';
import marginComment from './MarginComment.vue';
export default {
    directives: { mask },
    components: {
        OrderData,
        AddExtraRevenue,
        edtAssignment,
        rdTracking,
        CalculateMoq,
        ratesModal,
        ConfirmDialogue,
        UnfinalizeCause,
        marginComment
    },
    props:['searchShift'],
    data: function() {
        return {
            rateInfo: [],
            loadData: false,
            loadProgress: false,
            progress: false,
            value: '',
            dlt: [],
            items: [
                {
                    text: 'Details',
                    icon: 'mdi-card-account-details-outline',
                    action: 1
                },
                { text: 'Odos', icon: 'mdi-apps-box', action: 4 },
                { text: 'Totals', icon: 'mdi-star-circle', action: 2 },
                { text: 'Other', icon: 'mdi-dots-horizontal', action: 3 }
            ],

            disabled: null,
            params: {},
            btnPayroll: true,
            selectedItem: '',
            btnRevenue: true,
            color: 'purple',
            shifts: [],
            subMenu: 1,
            title: '',
            Moq: false,
            shift: [],
            orders: [],
            revTrans: [],
            payTrans: [],
            textbox: [],
            extraRevTrans: [],
            extraPayTrans: [],
            dialog: false,
            products: [],
            PaperworkOrigin: null,
            ShiftDetail: {
                0: {
                    ShiftDetail: '',
                    Yard: '',
                    Trailer: '',
                    Driver: '',
                    Truck: '',
                    ShiftStartTime: '',

                    ShiftEndsTime: '',
                    Shift: '',
                    ShiftDate: ''
                }
            },
            finalize: null,
            orderHeaders: [
                { text: 'Action', value: 'open', width: '1%' },
                { text: 'L1', value: 'LoadNum', width: '2%' },
                { text: 'L2', value: 'LoadNumOrd', width: '2%' },

                { text: 'Order', value: 'OrderID', width: '5%' },
                { text: 'Status', value: 'OrderStatus', width: '5%' },

                { text: 'BOL', value: 'BOL', width: '6%' },
                { text: 'Customer', value: 'Customer', width: '22%' },
                { text: 'Terminal', value: 'Terminal', width: '19%' },
                { text: 'Station', value: 'Station', width: '18%' },
                { text: 'City', value: 'StationCity', width: '8%' },
                {
                    text: 'Preload Order#',
                    value: 'PreloadOrderID',
                    width: '8%'
                }
            ],
            transHeaders: [
                { text: 'Order', value: 'OrderNumber', width: '5%' },
                {
                    text: 'Transaction Type',
                    value: 'TransactionName',
                    width: '25%'
                },
                { text: 'Qty', value: 'Quantity', width: '5%' },
                { text: 'Rate', value: 'Rate', width: '5%' },
                { text: 'Amount', value: 'Amount', width: '5%' },
                { text: 'InvId', value: 'InvId', width: '5%' },

                {
                    text: 'Actions',
                    value: 'save',
                    sortable: false,
                    width: '15%'
                }
            ],
            transPayHeaders: [
                { text: 'Order', value: 'OrderNumber', width: '5%' },
                {
                    text: 'Transaction Type',
                    value: 'TransactionName',
                    width: '25%'
                },
                { text: 'Qty', value: 'Quantity', width: '5%' },
                { text: 'Rate', value: 'Rate', width: '5%' },
                { text: 'Amount', value: 'Amount', width: '5%' },
                { text: 'PayId', value: 'PayId', width: '5%' },
                {
                    text: 'Actions',
                    value: 'save',
                    sortable: false,
                    width: '15%'
                }
            ]
        };
    },
    watch: {
        '$store.state.transacting.watch': function() {
            if (this.$store.state.transacting.watch == true) {
                this.loadShiftInfo();
                this.$store.state.transacting.watch = false;
            }
        },
        '$store.state.posting.mod': function() {
            this.loadPay();
        },
        '$store.state.transacting.watchMargin': function(){
            if (this.$store.state.transacting.watchMargin == true) {
                this.loadShift();
                this.$store.state.transacting.watchMargin= false;
            }
        }
    },
    async mounted() {
            this.loadShiftInfo();
    },
    computed: {
        totalRev: function() {
            var list = this.revTrans;
            var sum = 0;
            for (var rev in list) {
                sum += list[rev].Amount;
            }
            sum = Math.round((sum + Number.EPSILON) * 100) / 100;
            return sum;
        },
        totalExtraRev: function() {
            var list = this.extraRevTrans;
            var sum = 0;
            for (var rev in list) {
                sum += list[rev].Amount;
            }
            sum = Math.round((sum + Number.EPSILON) * 100) / 100;
            return sum;
        },
        totalPay: function() {
            var list = this.payTrans;
            var sum = 0;
            for (var rev in list) {
                sum += list[rev].Amount;
            }
            sum = Math.round((sum + Number.EPSILON) * 100) / 100;
            return sum;
        },
        totalExtraPay: function() {
            var list = this.extraPayTrans;
            var sum = 0;
            for (var rev in list) {
                sum += list[rev].Amount;
            }
            sum = Math.round((sum + Number.EPSILON) * 100) / 100;
            return sum;
        },
        net: function() {
            var net =
                this.totalRev +
                this.totalExtraRev +
                (this.totalPay + this.totalExtraPay);
            return Math.round((net + Number.EPSILON) * 100) / 100;
        },
        margin: function() {
            var margin = this.net / (this.totalRev + this.totalExtraRev);
            return Math.round((margin + Number.EPSILON) * 100) / 100;
        }
    },
    methods: {
        openCommentMargin: function() {
            this.$store.state.transacting.marginComment = true;
        },
        openEditAssig: function() {
            this.$store.state.assignment.dialog = true;
            this.$store.state.transacting.watch = false;
        },
        loadOrderDetails: function(orderID) {
            var str = this.$store;
            this.products = [];
            this.progress = true;
            axios
                .get('order-detail/order/' + orderID, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data.data);
                    this.products = response.data.data;
                    console.log(this.products);

                    this.progress = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }

                    this.progress = false;
                });
        },
        openRates: function(itm) {
            this.rateInfo = itm;
            this.$store.state.transacting.dialogRate = true;
        },
        loadShiftInfo: function() {
            this.$store.state.isLoading = true;
            this.loadShift();
            this.loadOrders();
            this.loadRev();
            this.loadExtraRev();
            this.loadPay();
            this.loadPaperworkOrigin();
            this.loadExtraPay();
            this.btnRevenue = true;
            this.btnPayroll = true;
            this.$store.state.transacting.watch = false;
        },
        loadShift: async function() {
            var str = this.$store;
            console.log(this.value);
            this.loadProgress = true;
            try {
                let response = await axios.get(
                    'shift-detail/resource/' + this.searchShift,
                    {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                );
                this.ShiftDetail = response.data;
                if (this.ShiftDetail[0].Finalize == 1) {
                    this.disabled = true;
                } else {
                    this.disabled = false;
                }
                this.loadProgress = false;
                this.loadData = true;
                console.log(this.ShiftDetail);
            } catch (error) {
                this.loadProgress = false;
                this.loadData = false;
                console.log(error);
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'Shift No Found'
                });
            }
        },
        ReadyToTransact: function(ready,id){
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                ReadyToTransact: ready ,
            };
            axios
                .put('shift-detail/'+id, parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    console.log(response.data);
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        finalizeShift: function(itm) {
            var parms = {
                Finalize: itm
            };
            axios
                .put('shift-detail/' + this.searchShift, parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    this.insertDisp(itm);
                    this.loadShiftInfo();
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        loadOrders: function() {
            console.log('loadOrders');
            axios
                .get('order/shift/' + this.searchShift, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.orders = response.data;
                    console.log(this.orders);
                    if (this.orders.length > 0) {
                        this.btnRevenue = false;
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        insertDisp: function(itm) {
            var parms = {};
            if (itm == 1) {
                parms = {
                    Type: 'Finalize',
                    Shift: this.searchShift
                };
            } else {
                parms = {
                    Type: 'Unfinalize',
                    Shift: this.searchShift
                };
            }
            axios
                .post('disp-order/insert', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        loadRev: function() {
            axios
                .get('transaction/revenue/' + this.searchShift, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.revTrans = response.data.data;

                    this.btnPayroll = false;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        loadExtraRev: function() {
            axios
                .get('transaction/extra-revenue/' + this.searchShift, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.extraRevTrans = response.data.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        loadPay: function() {
            axios
                .get('transaction/payroll/' + this.searchShift, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.payTrans = response.data.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        loadExtraPay: function() {
            axios
                .get('transaction/extra-payroll/' + this.searchShift, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.extraPayTrans = response.data.data;
                    console.log(this.extraPayTrans);
                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        newTransactRev: function(){
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .post('new-transactions/rev/' + this.searchShift, '', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response);
                    this.loadRev();
                    this.loadExtraRev();
                    this.btnPayroll = false;

                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        transactRev: function() {
            console.log('transactRev');
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .post('transaction/transact-rev/' + this.searchShift, '', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response);
                    this.loadRev();
                    this.loadExtraRev();
                    this.btnPayroll = false;

                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        newTransactPay: function(){
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .post('new-transactions/pay/' + this.searchShift, '', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    this.loadPay();
                    this.loadExtraPay();
                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        transactPay: function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .post('transaction/transact-pay/' + this.searchShift, '', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    this.loadPay();
                    this.loadExtraPay();
                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        saveShift: function() {
            var str = this.$store;
            var paperwork = null;
            if (this.ShiftDetail[0]['PaperworkOrigin'] != null) {
                paperwork = this.ShiftDetail[0]['PaperworkOrigin'].ID;
            }
            var params = {
                OdoStart: this.ShiftDetail[0]['OdoStart'],
                OdoEnd: this.ShiftDetail[0]['OdoEnd'],
                OdoTotal: this.ShiftDetail[0]['OdoTotal'],
                ReplUnitOdoStart: this.ShiftDetail[0]['ReplUnitOdoStart'],
                ReplUnitOdoEnd: this.ShiftDetail[0]['ReplUnitOdoEnd'],
                OutofProvOdoStart: this.ShiftDetail[0]['OutofProvOdoStart'],
                OutofProvOdoEnd: this.ShiftDetail[0]['OutofProvOdoEnd'],
                DailySummaryCheck: this.ShiftDetail[0]['DailySummaryCheck'],
                PaperworkOrigin: paperwork
            };
            console.log(params);
            axios
                .put('shift-detail/' + this.searchShift, params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Saved'
                    });
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        async onFinalizeShift() {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'You are about to finalize Shift #' + this.searchShift,
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.finalizeShift(1);
            }
        },
        async dltTrnsConfirm(itm) {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'You are about to delete this transaction',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.deleteTrnsaction(itm.TranId);
            }
        },
        async onUnFinalizeShift() {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'You are about to unfinalize Shift #' + this.searchShift,
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.$store.state.transacting.unfinalizedCause = true;
            }
        },
        deleteTrnsaction: function(itm) {
            var str = this.$store;
            axios
                .delete('transaction/' + itm, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Delete transaction successful.'
                    });
                    this.$store.state.transacting.watch = true;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },

        calculateAmountRevenue: function(itm) {
            if (itm.TranTypeId == 5 || itm.TranTypeId == 6) {
                const amount = itm.Quantity * itm.Rate;
                itm.Amount = Number(amount.toFixed(2));
            } else {
                const amount = (itm.Quantity * itm.Rate) / 1000;
                itm.Amount = Number(amount.toFixed(2));
            }
        },

        calculateAmountExtRevenue: function(itm) {
            const amount = itm.Quantity * itm.Rate;
            itm.Amount = Number(amount.toFixed(2));
        },
        calculateAmountExtPayrol: function(itm) {
            let amount = itm.Quantity * itm.Rate;
            if (amount > 0) {
                amount = amount * -1;
            }
            itm.Amount = Number(amount.toFixed(2));
        },
        calculateAmountPayroll: function(itm) {
            if (
                itm.TranTypeId == 21 ||
                itm.TranTypeId == 22 ||
                itm.TranTypeId == 21
            ) {
                let amount = itm.Quantity * itm.Rate;
                if (amount > 0) {
                    amount = amount * -1;
                }
                itm.Amount = Number(amount.toFixed(2));
            } else {
                let amount = (itm.Quantity * itm.Rate) / 1000;
                if (amount > 0) {
                    amount = amount * -1;
                }
                itm.Amount = Number(amount.toFixed(2));
            }
            console.log(itm);
        },
        openModalOrder: function(item) {
            this.$store.state.orderInfo.orderId = item.OrderID;
            console.log(item);
            this.$store.state.posting.dialog = true;
        },
        loadPaperworkOrigin: function() {
            axios
                .get('paperwork-origin', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.PaperworkOrigin = response.data;
                    console.log(this.PaperworkOrigin);
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        saveMore: function(itm) {
            console.log(itm);
            var parms = {
                AdmComments: itm.AdmComments,
                'No Rate': itm.NoRate,

                'Short Load': itm.ShortLoad,
                Other: itm.Other
            };
            console.log(parms);
            axios
                .put('shift-detail/' + itm.ShiftDetail, parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response);
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'saved successfully'
                    });
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        openModalNewExt: function(i, t) {
            this.$store.state.transacting.dialogAddExt = true;
            this.title = t;
            this.params = {
                id: this.searchShift,
                Type: i
            };
            this.$store.state.transacting.watch = false;
        },
        saveRevenue: function(itm) {
            console.log(itm);
            var parms = {
                Amount: itm.Amount,
                Quantity: itm.Quantity,
                Rate: itm.Rate,
                InvId: itm.InvId,
                Description: itm.Description
            };
            console.log(parms);
            axios
                .put('transaction/' + itm.TranId, parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response);
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'saved successfully'
                    });
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        savePayroll: function(itm) {
            console.log(itm);
            var parms = {
                Amount: itm.Amount,
                Quantity: itm.Quantity,
                Rate: itm.Rate,
                PayId: itm.PayId,
                Description: itm.Description
            };
            axios
                .put('transaction/' + itm.TranId, parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response);
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'saved successfully'
                    });
                })
                .catch(function(error) {
                    console.log(error);
                });
        }
    }
};
</script>
<style>
.tableTrasac tr > th {
    background: #01579b;
    color: #fff;
    text-align: center;
}
table.tbl-trs {
    border-collapse: collapse;
    font-size: 12px;
    color: #000;
    width: 100%;
}
.tbl-trs,
td {
    font-size: 13px;
}
.tbl-trs input {
    color: #000;
}
.tbl-trs input {
    width: 45px;
    box-sizing: border-box;
    border: none;
    border-bottom: 2px solid #000;
}
th {
    border-collapse: collapse;
}

td {
    height: 0px;
}
td:hover {
    background: none;
}
.tbl {
    height: 200px;
    overflow: scroll;
}
.summary-color .v-input__slot label {
    color: #000;
    font-size: 10px;
}
.tableTrasac td input {
    background: #fffae8;
}
</style>
